import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// Import Helmet for managing the document head

import './../../pagescss/Subjects.css';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';

function PYQMockTest() {

  


    const pageTitleText = "JEE PYQ Mock Tests";


    return (
        <>



            <div className="subject-page">

                {/* **Ensure these render as H1 and clear headings** */}
                <TopNavbar name={pageTitleText} />
                {/* Ideally, TopHeader renders the main H1 tag. */}
                <TopHeader name={pageTitleText} />



                <div className="subject-categories">

                    {/* All Subject Mock Test (Full-Length PYQ Mock) */}
                    <Link to={`/pyq-mock-test-year/${"previousyearquestions"}/${"atoz"}/${"atoz"}/${"All subject "}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                Δ
                            </div> 
                            <h2>Full  Mock Test  ➔</h2>
                        </div>

                    </Link>

                    {/* math Subject-wise PYQ Mock */}
                    <Link to={`/pyq-mock-test-year/${"previousyearquestions"}/${"math"}/${"atoz"}/${"Mathematics"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                🧬
                            </div>
                            <h2>Mathematics  ➔ </h2> 
                        </div>

                    </Link>

                    {/* Physics Subject-wise PYQ Mock */}
                    <Link to={`/pyq-mock-test-year/${"previousyearquestions"}/${"physics"}/${"atoz"}/${"Physics"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                ⚛
                            </div>
                            <h2>Physics  ➔</h2> 
                        </div>

                    </Link>

                    {/* Chemistry Subject-wise PYQ Mock */}
                    <Link to={`/pyq-mock-test-year/${"previousyearquestions"}/${"chemistry"}/${"atoz"}/${"Chemistry"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                ⚗
                            </div>
                            <h2>Chemistry  ➔ </h2> {/* Optimized Link Text */}
                        </div>

                    </Link>

                    
                </div>
            </div>
        </>
    );
}

export default PYQMockTest;